import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { BehaviorSubject, switchMap } from 'rxjs';
import { LocalStorageService } from '@shared/tools/local-storage.service';
import { B2B_CUSTOMER_ID_KEY, B2B_UNIT_ID_KEY } from '@shared/tools/constants';

import { SelectCartModalComponent } from '@b2b/components/cart/cart-list/components/select-cart-modal/select-cart-modal.component';

import { ModalService } from '@shared/components/modal-list/modal-list.service';

import { CartService } from '@b2b/features/cart/core/cart.service';
import { CartList } from '@b2b/features/cart/utilities/cart-list-model';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from '@app/core/user/user.service';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';

@Component({
  selector: 'cart-list',
  imports: [CommonModule, RouterModule, TableModule, TranslateModule, PaginationComponent],
  templateUrl: './cart-list.component.html',
  styleUrl: './cart-list.component.scss',
})
export class CartListComponent {
  private pageSubject = new BehaviorSubject(1);
  page$ = this.pageSubject.asObservable();
  user$ = this.userService.get();

  currentCart$ = this.cartService.getCart();
  carts$ = this.user$.pipe(
    switchMap(() => {
      const customerId = this.localStorage.getItem(B2B_CUSTOMER_ID_KEY) || '';
      const b2bUnitId = this.localStorage.getItem(B2B_UNIT_ID_KEY) || '';
      return this.page$.pipe(switchMap(page => this.cartService.getCartList({ page }, customerId, b2bUnitId)));
    }),
  );

  columns$ = new BehaviorSubject([
    { field: 'code', label: 'ID' },
    { field: 'name', label: 'Nome' },
    { field: 'updatedAt', label: 'Atualizado em' },
    { field: 'totalEntries', label: 'QTDE' },
    { field: 'totalPrice', label: 'Total' },
    { field: 'action', label: 'Ação' },
  ]);

  constructor(
    private cartService: CartService,
    private userService: UserService,
    private localStorage: LocalStorageService,
    private router: Router,
    private modalService: ModalService<CartList>,
  ) {}

  goToPage(page: number) {
    this.pageSubject.next(page);
  }

  goBack() {
    this.router.navigate(['carrinho']);
  }

  selectCart(cart: CartList) {
    this.modalService.addModal({
      data: cart,
      disableClose: false,
      hasCloseButton: true,
      id: 'save-cart-modal',
      title: '',
      width: 430,
      component: SelectCartModalComponent,
    });
  }
}
